import { forwardRef, type MouseEvent, type Ref } from 'react';
import { Link } from 'react-router-dom';

import CoreAnchor, {
    type AnchorProps as CoreAnchorProps,
    type AnchorElementType,
} from '@ovpn/ui/anchor';

import type { AnyRecord } from '@sso/shared/types';
import { boxed } from '@sso/shared/hocs';

type AsButtonProps = {
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
    target?: never;
    href?: never;
    state?: never;
    replace?: never;
    to?: never;
};

type AsLinkProps = {
    onClick?: never;
    target?: never;
    href?: never;
    state?: AnyRecord;
    replace?: boolean;
    to?: string;
};

type AsAnchorProps = {
    onClick?: never;
    target?: string;
    href?: string;
    state?: never;
    replace?: never;
    to?: never;
};

export type AnchorProps = CoreAnchorProps<AnchorElementType> &
    (AsButtonProps | AsLinkProps | AsAnchorProps);

function Anchor(
    { children, style, as: asProp, ...props }: AnchorProps,
    ref: Ref<HTMLAnchorElement>,
) {
    let as: AnchorElementType | undefined = asProp;
    if (props.onClick) as = 'button';
    if (props.to) as = Link;

    return (
        <CoreAnchor {...props} ref={ref} as={as}>
            {children}
        </CoreAnchor>
    );
}

export default boxed<AnchorProps, AnchorElementType>(forwardRef(Anchor));
